import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useState } from "react";

import { Select2ApplyBar } from "~/components/select2";

export interface PriceRangePopoverProps {
  initialFrom: string;
  initialTo: string;
  onApply: (from: string, to: string) => void;
  onClose: () => void;
}

export function PriceRangePopover({
  initialFrom,
  initialTo,
  onApply,
  onClose,
}: PriceRangePopoverProps) {
  const [from, setFrom] = useState(initialFrom);
  const [to, setTo] = useState(initialTo);
  const apply = () => {
    onApply(from.trim(), to.trim());
    onClose();
  };
  return (
    <Stack>
      <Stack sx={{ minWidth: 240 }} spacing={4}>
        <TextField
          size="small"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          label="From"
          inputMode="decimal"
        />
        <TextField
          size="small"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          label="To"
          inputMode="decimal"
        />
      </Stack>
      <Select2ApplyBar onApply={apply} />
    </Stack>
  );
}
